export class WorkFlowChangeReplyUserRequest {
  token?: string;
  workFlowId?: number;
  newUserId?: string;
}
